import { multilingual_url } from "./multilingual-url";

/**
 * How to use:
 * 1. Create an empty template of the page where the section is located with the "ajax" name (ex: index.ajax.liquid)
 * 2. Wrap the code that you want to be lazy loaded in an {% if template contains "ajax" %}
 * 3. Add a data-lazy-content attribute to an element around that if statement where the value is a unique name for that content (ex: data-lazy-content="product-{{forloop.index}}")
 *
 * This function use the section rendering API and load all the content that has a data-lazy-content attribute,
 * it will use the value of the attribute to know which content goes where.
 *
 * @param {*} elementContainer DOMElemnt - container of the element to be lazy loaded
 */
export const lazyContent = async (elementContainer, customPath) => {
  const sectionId = elementContainer.closest(".shopify-section").id.replace("shopify-section-", "");

  const elementsToLazyLoad = elementContainer.querySelectorAll('[data-lazy-content]');
  if (elementsToLazyLoad.length > 0) {
    elementsToLazyLoad.forEach(element => {
      element.classList.add('loading');
    });

    let path = window.location.pathname;
    if (customPath) {
      path = multilingual_url(customPath);
    }

    const section = await fetch(`${path}?sections=${sectionId}&view=ajax`);
    const sectionsJson = await section.json();
    const sectionHtml = sectionsJson[sectionId];

    const parser = new DOMParser();
    const sectionDocument = parser.parseFromString(sectionHtml, 'text/html');
    const lazyContentElements = sectionDocument.querySelectorAll('[data-lazy-content]');

    lazyContentElements.forEach(element => {
      const elementsToReplace = elementContainer.querySelectorAll(`[data-lazy-content="${element.dataset.lazyContent}"]`);
      elementsToReplace.forEach(elementToReplace => {
        elementToReplace.innerHTML = element.innerHTML;
        elementToReplace.classList.remove('loading');
      });
    });

    if (!sectionHtml) {
      elementsToLazyLoad.forEach(element => {
        element.classList.remove('loading');
      });
    }
  }
}
